
/** --------------------------------------------------------------------------------------------------
 * 開啟'儲存中'視窗
 * -------------------------------------------------------------------------------------------------- */
window.showLoadingDialog = function () {
    $("#dialog-saving").show();
}

window.hideLoadingDialog = function (){
    $("#dialog-saving").hide();
}
